import type {
  AppSettings,
  CmsPages,
  ThousandSeparator,
  VisibilitySetting,
} from '@spa/types/appSettings.types';

export function getAppSettings(): Omit<Partial<AppSettings>, 'pages'> & {
  pages: Partial<CmsPages>;
} {
  const { pages, ...rest } = window.BioMarAppSettings ?? {};
  return { ...rest, pages: pages ?? {} };
}

//   'dot'   → 'de-DE'  — 1.000
//   'comma' → 'en-US'  — 1,000
//   'space' → 'fi-FI'  — 1 000
export const SEPARATOR_LOCALE_MAP: Record<ThousandSeparator, string> = {
  dot: 'de-DE',
  comma: 'en-US',
  space: 'fi-FI',
};

export const FORECAST_SUPPORTED_LOCALES = ['no-NO'] as const;

export function isVisibilityEnabled(
  value: VisibilitySetting | undefined,
  defaultValue = true
): boolean {
  return value === undefined ? defaultValue : value !== false && value !== 'false';
}

export function isForecastSupported(): boolean {
  const language = getAppSettings().language;

  return FORECAST_SUPPORTED_LOCALES.includes(
    language as (typeof FORECAST_SUPPORTED_LOCALES)[number]
  );
}

export function isReportsPageEnabled(): boolean {
  return isVisibilityEnabled(getAppSettings().pages.enableReportsPage);
}
